const translations = {
    amsDriver: 'Based on {{driver}}',
    amsRecommendationText: 'Add {{amount}} lb AMS per 100 gallons',
    amsTitle: 'Water conditioner recommendation',
    citationLink: 'Source',
    cleanMessage: 'No tank-mix interactions flagged.',
    defaultWaterProfileNotice:
        'Using a default water profile. Field-specific AMS + pH advisories require a tenant water profile.',
    driverLabels: {
        FORMULA: 'Agvise hard-water formula',
        HARDNESS_FLOOR: 'Hard-water floor (total CaCO3)',
        LABEL_MINIMUM: 'Label minimum'
    },
    errorMessage: 'Compatibility advisory temporarily unavailable. Findings may be stale.',
    interactionsTitle: 'Pair interactions ({{count}})',
    loading: 'Checking compatibility…',
    pairDescription: '{{firstName}} + {{secondName}} — {{interactionType}}',
    phAbove: 'Degrades above pH {{threshold}} (observed {{observed}})',
    phBelow: 'Degrades below pH {{threshold}} (observed {{observed}})',
    phTitle: 'pH stability warnings ({{count}})',
    title: 'Tank compatibility'
};

export default translations;
